
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PerformanceMonitor = () => {
  const location = useLocation();
  
  // Track initial page load performance
  useEffect(() => {
    if (window.performance) {
      const navStart = window.performance.timing.navigationStart;
      const loadComplete = window.performance.timing.loadEventEnd;
      const totalTime = loadComplete - navStart;
      
      console.log('🚀 App initialized in:', totalTime, 'ms');
    }
  }, []);

  // Track route changes
  useEffect(() => {
    const routeStart = performance.now();
    
    // Record time after component renders
    setTimeout(() => {
      const routeEnd = performance.now();
      const routeTime = routeEnd - routeStart;
      
      console.log(`🔄 Route changed to: ${location.pathname}`);
      console.log(`⏱️ Route loaded in: ${routeTime.toFixed(2)} ms`);
    }, 0);
  }, [location]);

  return null;
};

export default PerformanceMonitor;